import { render, staticRenderFns } from "./user-search.vue?vue&type=template&id=0b07ae9d&"
import script from "./user-search.vue?vue&type=script&lang=js&"
export * from "./user-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports